import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { AddNoteRequest } from "./AddNoteRequest";
import { GetNotesRequest } from "./GetNotesRequest";
import { GetNotesResponse } from "./GetNotesResponse";

export const useNoteApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const orderApiUrl = appConfigContext.ordersConfig.apiUrl;

    const { httpPost, httpGet } = useAuthorizedFetch();

    const addOrderNote = async (request: AddNoteRequest): Promise<void> => {
        return httpPost(`${orderApiUrl}/notes`, request);
    };

    const getOrderNotes = async (query: GetNotesRequest): Promise<GetNotesResponse> => {
        return httpGet<GetNotesResponse>(`${orderApiUrl}/notes`, query);
    };

    return {
        addOrderNote,
        getOrderNotes
    };
};
